// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f93b87f6","667":"2c4c721c","977":"40a5111d"}[chunkId] + ".chunk.js";
};